/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface AbstractStep { 
    description?: string;
    type?: AbstractStep.TypeEnum;
    createdAt?: Date;
    updatedAt?: Date;
    complete?: boolean;
}
export namespace AbstractStep {
    export type TypeEnum = 'CONDITION_IF' | 'EMAIL' | 'SMS' | 'DELAY' | 'LANDING_PAGE_EVENT' | 'CHANGE_DATA_EVENT' | 'EMAIL_EVENT' | 'SAVE_QUERY' | 'START' | 'END';
    export const TypeEnum = {
        CONDITIONIF: 'CONDITION_IF' as TypeEnum,
        EMAIL: 'EMAIL' as TypeEnum,
        SMS: 'SMS' as TypeEnum,
        DELAY: 'DELAY' as TypeEnum,
        LANDINGPAGEEVENT: 'LANDING_PAGE_EVENT' as TypeEnum,
        CHANGEDATAEVENT: 'CHANGE_DATA_EVENT' as TypeEnum,
        EMAILEVENT: 'EMAIL_EVENT' as TypeEnum,
        SAVEQUERY: 'SAVE_QUERY' as TypeEnum,
        START: 'START' as TypeEnum,
        END: 'END' as TypeEnum
    };
}
